<template>
    <div>
        <el-radio-group
            v-if="radioStyle === 'button'"
            v-model="selectedValue"
            :disabled="mode !== 'edit' || disabled"
        >
            <el-radio-button
                v-for="choice in choices"
                :key="choice.value"
                :value="choice.value"
                :disabled="choice.disabled"
            >
                {{ $filters.capitalize(choice.label) }}
                <p
                    v-if="choice.sublabel"
                    class="mt-1 mb-0 regular"
                    :class="btnTextColor(choice.value)"
                >
                    {{ $filters.capitalize(choice.sublabel) }}
                </p>
            </el-radio-button>
        </el-radio-group>

        <el-radio-group v-else v-model="selectedValue" :disabled="mode !== 'edit' || disabled">
            <el-radio
                v-for="choice in choices"
                :key="choice.value"
                :label="choice.label"
                :value="choice.value"
                :disabled="choice.disabled"
            />
        </el-radio-group>
    </div>
</template>

<script>
export default {
    props: {
        mode: {
            type: String,
            default: 'edit',
        },
        radioStyle: {
            type: String,
            default: '',
        },
        modelValue: {
            type: [Number, String, Boolean],
            required: false,
            default: false,
        },
        choices: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ['update:modelValue', 'change'],
    data() {
        return {
            selectedValue: '',
        };
    },
    watch: {
        value(newValue) {
            this.selectedValue = newValue;
        },
        selectedValue(newValue) {
            this.$emit('update:modelValue', newValue);
            this.$emit('change', newValue);
        },
    },
    mounted() {
        this.selectedValue = this.modelValue;
    },

    methods: {
        btnTextColor(value) {
            return this.selectedValue === value ? 'white' : 'grey';
        },
    },
};
</script>
